import { PriorityStatusButton } from '../PriorityStatusButton'
import {
  PlanOrganizationTaskStatus,
  type PlanOrganizationTask
} from '../../../../../models/PlanOrganizationTask'
import { type AnnualPlanRole } from '../../../../../models/AnnualPlanRole'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { UpdatePlanOrganizationTaskStatus } from '../../../../../services/AnnualPlanService'
import { Modal } from '../../../../customComponents/Modal'

interface Props {
  planOrganizationTask: PlanOrganizationTask
  userRole: AnnualPlanRole | null
  handleStatusChange: (status: PlanOrganizationTaskStatus) => void
  disableStatus: boolean
  annualPlanId: number
  implementationPhase?: boolean
}
export const RCNOperationsStatusButton = (props: Props): JSX.Element => {
  const [isConfirmingAccept, setIsConfirmingAccept] = useState<boolean>(false)
  const [isConfirmingInProgress, setIsConfirmingInProgress] = useState<boolean>(false)

  const handleStatusChange = async (status: PlanOrganizationTaskStatus): Promise<void> => {
    if (status === PlanOrganizationTaskStatus.Accepted) {
      setIsConfirmingAccept(true)
      return
    }

    if (status === PlanOrganizationTaskStatus.InProgress && props.planOrganizationTask?.status === PlanOrganizationTaskStatus.Accepted) {
      setIsConfirmingInProgress(true)
      return
    }

    await confirmStatusChange(status)
  }

  const confirmStatusChange = async (status: PlanOrganizationTaskStatus): Promise<void> => {
    if (props.planOrganizationTask == null) {
      return
    }

    const { success, errors } = await UpdatePlanOrganizationTaskStatus(props.planOrganizationTask.id, status)

    if (!success) {
      if (errors.length > 0) errors.forEach((e) => toast.error(e))
      else toast.error('An error occurred while updating the status.')
    } else {
      setIsConfirmingAccept(false)
      setIsConfirmingInProgress(false)
      props.handleStatusChange(status)

      if (status === PlanOrganizationTaskStatus.Accepted) {
        toast.success('This task has been accepted.')
      }
    }
  }

  return <>
    {props.planOrganizationTask != null && (
      <PriorityStatusButton
        rcnOperations={true}
        currentStatus={props.planOrganizationTask.status}
        userRole={props.userRole}
        onChange={handleStatusChange}
        disabled={props.disableStatus}
        implementationPhase={props.implementationPhase}
      />
    )}

    {isConfirmingAccept &&
      <Modal
        open={true}
        title='Confirm Accept'
        cancelButtonText='No, Cancel'
        confirmButtonText='Yes, Continue'
        onClose={() => { setIsConfirmingAccept(false) }}
        onConfirm={async () => { await confirmStatusChange(PlanOrganizationTaskStatus.Accepted) }}
        bodyContent='This will lock the Meeting Schedule and mark the task as "Accepted." Do you wish to continue?'
      />
      }

    {isConfirmingInProgress &&
      <Modal
        open={true}
        title='Confirm In Progress'
        cancelButtonText='No, Cancel'
        confirmButtonText='Yes, Continue'
        onClose={() => { setIsConfirmingInProgress(false) }}
        onConfirm={async () => { await confirmStatusChange(PlanOrganizationTaskStatus.InProgress) }}
        bodyContent='This will unlock the Meeting Schedule and mark the task as "In Progress." Do you wish to continue?'
      />
      }
  </>
}
